import React, {Component, useState, useEffect, useRef} from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames';
import querystring from 'query-string'
import autobind from 'autobind-decorator';

import PostHeadFilterPanel from './PostHeadFilterPanel';
import EntryItemAllCheckbox from '../../common/EntryItemAllCheckbox';
import { parseListParams } from './PostListHelper';

import { selectAllItems, deselectAllItems, receiveItems} from '../../../actions/contents/post';
import TSelectFilter from "../../common/TSelectFilter";
import EntryHeaderStatusChangeButton from "../EntryHeaderStatusChangeButton"
import EntryHeaderSearchButton from "../EntryHeaderSearchButton"

function LoadingSearchItems({searchKeyword, searchType, searchTypeOptions}) {
  return (
    <div className="wrap_search loading_search">
      <TSelectFilter
        className={"filter_search"} items={searchTypeOptions}
        disabled={true} selected={searchType}
        onSelect={(item, idx) => {}}
      />
      <em className="txt_keyword">{searchKeyword}</em>
      <span className="txt_change">
        검색중<span className="ico_blog ico_change"/>
      </span>
    </div>
  )
}


@connect(state => ({
  items: state.post.item.items,
  searchKeyword: state.post.condition.searchKeyword,
  searchType: state.post.condition.searchType,
}), dispatch => ({
  handleSelectAllItems: () => {
    dispatch(selectAllItems())
  },
  handleDeselectAllItems: () => {
    dispatch(deselectAllItems())
  },
  handleReceivePosts: (items, totalCount) => {
    dispatch(receiveItems(items, totalCount))
  },
  dispatch
}))
class PostListHeader extends Component {

  constructor(props, context) {
    super(props, context);

    this.searchText = React.createRef()

    this.state = {
      optionOpen: false,
      activateFilterList : false,
      searchOpen: false,
      searching: false,
      searchKeyword : '',
      searchType: 'title',
      searchTypeOptions : [{ label : '제목', value: 'title'},
        { label : '내용', value: 'content'},
        { label : '태그', value: 'tag'}]
    };
  }

  componentWillReceiveProps(nextProps) {
    const { searchKeyword, searchType } = this.state;
    const nextSearchKeyword = nextProps.searchKeyword;
    const nextSearchType = nextProps.searchType;

    if(nextSearchKeyword === '' || (searchKeyword === nextSearchKeyword && searchType === nextSearchType)){
      this.setState({
        searching: false,
      });
    }
  }

  @autobind
  toggleFilterList(e) {
    const { activateFilterList } = this.state;

    if(activateFilterList) {
      this.setState({
        activateFilterList: false
      });
    }else{
      this.setState({
        optionOpen : false,
        activateFilterList: true
      });
    }
  }

  @autobind
  closeFilterList(e) {
    this.setState({
      activateFilterList: false
    });
  }

  @autobind
  handleSelectAll(e) {
    const { handleSelectAllItems, handleDeselectAllItems } = this.props
    if (e.target.checked) {
      handleSelectAllItems()
    } else {
      handleDeselectAllItems()
    }
  }

  @autobind
  handleChangeOpenOption(open) {
    if (open) {
      this.setState({
        optionOpen: true,
        activateFilterList : false
      })
    } else {
      this.setState({
        optionOpen: false
      })
    }
  }

  @autobind
  handleOpenSearch(e) {
    this.setState({
      searchOpen: true,
      searchKeyword:'',
      searchType : 'title',
      activateFilterList : false,
    });
  }

  @autobind
  handleCloseSearch(e) {
    this.setState({
      searchOpen: false,
      optionOpen: false,
    })
  }

  @autobind
  handleSearch(e) {
    const { searchKeyword, searchType}  = this.state;

    e.preventDefault();

    let history = this.props.history;
    let location = this.props.location;

    if (searchKeyword.length > 0) {
      let listParams = parseListParams(location.search);
      if (listParams.searchKeyword !== searchKeyword || listParams.searchType !== searchType) {
        this.setState({
          searching: true,
        })
        history.push(location.pathname + "?" + querystring.stringify({searchKeyword: searchKeyword, searchType : searchType}));
      }
    }
    this.handleCloseSearch();
  }

  @autobind
  searchUpdated (value) {
    this.setState({searchKeyword: value})
  }

  @autobind
  selectSearchType(item, idx) {
    this.setState({
      searchType: item.value
    })
  }

  render() {
    const { optionOpen, searchOpen, searchKeyword, searching, activateFilterList, searchTypeOptions, searchType} = this.state;
    const { items } = this.props;

    if (searching) {
      return (
        <LoadingSearchItems
          searchKeyword={searchKeyword}
          searchType={searchType}
          searchTypeOptions={searchTypeOptions}
        />
      )
    }

    return (
      <div className={classnames({"wrap_search": true, "on": searchOpen})}>
        <EntryItemAllCheckbox
          items={items}
          handleSelectAll={this.handleSelectAll}
        />

        <EntryHeaderSearchButton
          searchOpen={searchOpen}
          searchKeyword={searchKeyword}
          searchType={searchType}
          searchTypeOptions={searchTypeOptions}
          onChangeSearchType={this.selectSearchType}
          onChangeKeyword={this.searchUpdated}
          onOpen={this.handleOpenSearch}
          onClose={this.handleCloseSearch}
          onSearch={this.handleSearch}
          placeholder={"글 관리에서 검색합니다."}
        />

        <EntryHeaderStatusChangeButton
          type={'posts'}
          items={items}
          optionOpen={optionOpen}
          onChangeOpen={this.handleChangeOpenOption}
        />

        <PostHeadFilterPanel
          activateFilterList={activateFilterList}
          toggleFilterList={this.toggleFilterList}
          closeFilterList={this.closeFilterList}
        />
      </div>
    )

  }
}

export default PostListHeader;
